module.exports = __webpack_public_path__ + "static/media/like.419e6693.svg";